<template>
    <div class="activitate ">
        <div class="header " :class="{ warning: !checked }">
            <span class="title" ><strong>{{ boldTitle }}</strong>{{ " - " + title }}</span>
            <div class="actions">
                <b-icon-check-circle-fill v-if="checked" font-scale="1.4" class="check"></b-icon-check-circle-fill>
                <b-icon-x-circle-fill v-else font-scale="1.4" class="deny"></b-icon-x-circle-fill>
            </div>
        </div>
        <small v-if="!checked" class="warning_text">Această sectiune necesită completari suplimentare</small> 
    </div>
</template>
<script>
    import { BIconCheckCircleFill,BIconXCircleFill} from "bootstrap-vue";
    export default {
        components:{
            BIconCheckCircleFill,
            BIconXCircleFill
        },
        props:{
            title:{
                type:String,
                default:"Title"
            },
            boldTitle:{
                type:String,
                default:"Bold Title"
            },
            checked:{
                type:Boolean,
                default:false
            }
        }
    }
</script>
<style  scoped>
.activitate{
    margin-top: 10px;
}
.activitate .header{
    background: #e9eaec;
    padding: 15px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.activitate .actions svg:first-child{
    margin-right: 10px;
}
.check{
   
    fill: #49cda8;
}
.deny{
    fill: #ff6767;
}
.warning_text{
    color:#ff6767; ;
}
.warning{
    background: #ffd6d6 !important; 
}
.activitate .header span{
    color: #515679;
}
</style>